export enum SystemServerVersionsAPIRoutes {
    GET_SYSTEM_SERVER_VERSIONS = "config:lists:versions:system_server",
    TOGGLE_SYSTEM_SERVER_VERSION_STATUS = "config:lists:versions:system_server:status:change"
}
